import Enum from '@square/dashboard-utilities/utils/enum';
import { ProtoBaseModel, attr, repeated } from '@square/dashboard-data/utils/ember-model-stubs';
import InstrumentSummary from '@square/dashboard-data/models/squareup/simple-instrument-store/api/instrument-summary';
export default ProtoBaseModel.extend({
  error: attr(String),
  instrument: repeated(InstrumentSummary, {
    defaultValue: []
  })
});
export const UnlinkingSource = new Enum(['UNKNOWN', 'AUTOMATIC', 'DASHBOARD', 'XP_API', 'REGISTER_CLIENT', 'BUYER_DASHBOARD']);
export const EntityTokenType = new Enum(['DO_NOT_USE', 'APPOINTMENT', 'PERSON', 'WEB_MERCHANT', 'MERCHANT_CONTACT', 'LOYALTY_CONTACT']);
export const Entity = ProtoBaseModel.extend({
  tokenType: attr(EntityTokenType),
  token: attr(String)
});
export const UnlinkContext = ProtoBaseModel.extend({
  unlinkingSource: attr(UnlinkingSource),
  entity: attr(Entity)
});
export const UnlinkInstrumentOnFileRequest = ProtoBaseModel.extend({
  merchantToken: attr(String),
  contactToken: attr(String),
  instrumentToken: attr(String),
  unlinkContext: attr(UnlinkContext)
});
export const UnlinkInstrumentOnFileResponse = ProtoBaseModel.extend({
  success: attr(Boolean)
});